import apiV2 from 'utils/apiV2'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/prompt/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/prompt/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/prompt/FETCH_FAILURE'

// Initial State
const initialState = {
  errors: [],
  list: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadPrompts() {
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = apiV2('/v2/prompts')
      .then(({ data }) => {
        dispatch(fetchSuccess({ data }))

        return { success: true, data }
      })
      .catch((error) => {
        const errors = handleError(error)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        list: payload.data || [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors,
      }
    default:
      return state
  }
}
